import { render, staticRenderFns } from "./EmployeeAttachments.vue?vue&type=template&id=4ad6d327"
import script from "./EmployeeAttachments.vue?vue&type=script&lang=js"
export * from "./EmployeeAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports